import React, { useEffect, useState } from 'react'
import ExpenseRegisterModel from './models/ExpenseRegisterModel'

function DeleteExpenseRegister({ ExpenseRegisterData }) {
  const [deleteExpenseRegister, setDeleteExpenseRegister] = useState(new ExpenseRegisterModel() || [])

  useEffect(() => {
    setDeleteExpenseRegister(ExpenseRegisterData)
  }, [ExpenseRegisterData])

  return (
    <>
      <div className="text-left px-2 pb-0">
        <p>
          <h6>Following Expense Register entry will be deleted and could not be recovered!!</h6>
          <ul>
            <li><b>Expense Category :</b> {deleteExpenseRegister.ExpenseCategoryName}</li>
            <li><b>Expense Date :</b> {deleteExpenseRegister.ExpenseDate ? deleteExpenseRegister.ExpenseDate.split('T')[0] : ''}</li>
            <li><b>Amount :</b> {deleteExpenseRegister.Amount}</li>
            <li><b>Reference :</b> {deleteExpenseRegister.ReferenceNo}</li>
          </ul>
        </p>
      </div>
      <div id="DeleteExpenseRegisterDetails" hidden>{JSON.stringify(deleteExpenseRegister)}</div>
    </>
  )
}

export default DeleteExpenseRegister
